module.exports = __webpack_public_path__ + "static/media/iconomegusto.2d1f1142.svg";